import { Stack, styled } from '@mui/material';

export const EmailConfigContainer = styled(Stack)({
  borderRadius: 12,
  padding: '14px 16px',
  border: '1px solid rgba(224, 224, 224, 1)',
  backgroundColor: 'rgba(255, 255, 255, 1)',
  marginTop: 20,
});
